module.exports = __webpack_public_path__ + "static/img/icon_float_times.ccc7a895.png";